module.exports = __webpack_public_path__ + "static/img/addressDefault.340170ab.png";